import React from 'react'
import DetailQuote from '../components/DetailQuote/DetailQuote'
import { useCustomerDisplay } from '../context/CustomerDisplayContext'

export default function DetailQuotePage() {
  const { quoteData, productsData, showDiscount, isLoadingDetailQuote } =
    useCustomerDisplay()

  return (
    <DetailQuote
      quote={quoteData}
      products={productsData}
      isLoadingDetailQuote={isLoadingDetailQuote}
      showDiscount={showDiscount}
    />
  )
}
